<template>
    <div>

        <div class="container-fluid text-center">

            <img :src="'/storage/workplace-clinic-images/'+clinic_image" class="w-50 rounded-circle mb-7"
                 style="max-width: 260px;"
                 v-if="clinic_image">

            <h1 class="mb-5">{{ clinic_name_person }}</h1>

            <p class="mb-6 text-start">{{ clinic_description }}</p>
        </div>

    </div>
</template>

<script>
export default {

    props: {
        clinic_name_person: {
            required: true
        },
        clinic_description: {
            required: true
        },
        clinic_image: {
            required: true
        }
    },

    data () {
        return {}
    },

    methods: {}
}
</script>
